export default "__VITE_ASSET__BDyTu8u8__"